<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Damage Product Re-Order</p>
          </div>
        </div>
        <!-- <div class="level-right">
          <div class="level-item">
            <router-link slot="right" :to="{ name: 'listKitMapping' }" class="button is-small is-link">Back to list</router-link>
          </div>
        </div> -->
      </div>
    </section>
    <form @submit.prevent="onSubmit" enctype="multipart/form-data" name="SaveWowKitMapping">
      <!-- <card-component>
        <div class="columns">
          <div class="column"></div>
          <div class="column is-half"></div>
        </div>
      </card-component> -->
      <card-component>
        <template>
          <div class="columns is-mobile">
            <div class="column " v-if="jsonData.length > 0">
              Uploaded .CSV Response

              <!-- <table class="mytabletable grid" cellpadding="0" cellspacing="0">
                <thead>
                  <tr>
                    <th class="column_1">
                      <div class="column_inner">Product Id</div>
                    </th>
                    <th class="column_2">
                      <div class="column_inner">Quantity</div>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="p in jsonData" :key="p.productID">
                    <td class="column_1 first_column">{{ p.productID }}</td>
                    <td class="column_2">{{ p.quantity }}</td>
                  </tr>
                </tbody>
              </table> -->
            </div>
            <div class="column ">
              <section class="text-is-centered">
                <b-field>
                  <b-upload v-model="dropFiles" @input="csvToJsonInput(dropFiles)" accept=".csv" single drag-drop title="Please do upload .csv file only">
                    <section class="section">
                      <div class="content has-text-centered">
                        <p>
                          <b-icon icon="upload" size="is-large"> </b-icon>
                        </p>
                        <p>Drop your files here or click to upload</p>
                      </div>
                    </section>
                  </b-upload>
                </b-field>
                <div v-show="flag">
                  <span class="tag is-primary">
                    {{ dropFiles.name }}
                    <button class="delete is-small" type="button" @click="deleteDropFile()"></button>
                  </span>
                </div>
              </section>
            </div>
            <div class="column "></div>
          </div>
          <footer class="column has-text-right">
            <button class="button is-success" type="submit">Save</button>
          </footer>
        </template>
      </card-component>
    </form>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import csvtojsonV2 from 'csvtojson'

export default {
  name: 'DamageReOrder',
  components: {
    CardComponent
  },

  data () {
    return {
      flag: '',
      jsonData: [],

      dropFiles: [],

      total: 0,
      paginated: false,
      kit: {},
      perPage: 10,
      loadingComponent: null,
      constantKit: constants.KIT,
      fileinput: '',
      isResponse: false
    }
  },

  methods: {
    readerFile: function (file, onLoadCallback) {
      var reader = new FileReader()
      reader.onload = onLoadCallback
      reader.readAsText(file)
    },
    csvToJsonInput: async function (files) {
      this.loadingComponent = this.$buefy.loading.open()

      this.isResponse = false
      let self = this
      if (files.length > 1) {
        this.dropFiles.splice(0, 1)
      }
      let file = files

      this.readerFile(file, async e => {
        try {
          self.jsonData = await csvtojsonV2().fromString(e.target.result)
        } catch (e) {
          self.jsonData = 'this is not running'
        }

        if (!self.jsonData[0].productID) {
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: 'Seems wrong format',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
        }

        self.jsonData.forEach(Obj => {})
      })
      this.flag = true
      this.loadingComponent.close()
    },

    deleteDropFile (index) {
      this.isResponse = false
      delete this.dropFiles.name
      this.jsonData = []
      this.dropFiles = []
      this.flag = false
      return this.dropFiles
    }

    // async onSubmit (event) {
    //   let that = this
    //   this.hasClicked = true
    //   this.loader = true
    //   this.loadingComponent = this.$buefy.loading.open()

    //   /* Add Record */
    //   try {
    //     await http.post(`${constants.API_URL}/api/kits/product-map/${this.classID}`, { products: that.jsonData })
    //     this.loadingComponent.close()

    //     this.loader = false
    //     this.$router.push({ name: 'listKitMapping' })
    //     return this.$buefy.dialog.alert({
    //       type: 'is-success',
    //       message: 'List Saved successfully!',
    //       hasIcon: true,
    //       animation: 'zoom-out',
    //       size: 'is-medium',

    //       icon: ' mdi-exclamation',
    //       iconPack: 'mdi',
    //       ariaRole: 'alertdialog',
    //       ariaModal: true
    //     })
    //   } catch (e) {
    //     this.loadingComponent.close()

    //     const errorMessage = (e && e.response && e.response.data.message) || e.message
    //     console.log('Error While Saving  List', errorMessage)

    //     return this.$buefy.dialog.alert({
    //       message: errorMessage,
    //       type: 'is-danger',
    //       hasIcon: true,
    //       animation: 'zoom-out',
    //       size: 'is-medium',

    //       icon: ' mdi-exclamation',
    //       iconPack: 'mdi',
    //       ariaRole: 'alertdialog',
    //       ariaModal: true
    //     })
    //   }
    // }
  }
}
</script>
<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
td {
  border: 1px dashed black;
  padding: 5px;
}
th {
  background: orange;
}
</style>
